import { useHtmlId } from '@ipfabric/frontend-shared-assets/utils/react/HtmlId';
import {} from 'react-hook-form';
import { FileUpload } from '../FileUpload/FileUpload';
import type { FileUploadProps } from '../FileUpload/FileUpload.types';
import { FormField } from '../FormField/FormField';
import type { FormFieldBaseProps } from '../FormField/FormField.types';

export type FileUploadFieldProps = FileUploadProps & FormFieldBaseProps;

export const FileUploadField = (props: FileUploadFieldProps) => {
  const { className, error, name, ...restProps } = props;

  const fileUploadInputId = useHtmlId('fileUploadInput');

  return (
    <FormField
      {...restProps}
      className={className}
      htmlFor={fileUploadInputId}
      error={error}
    >
      <FileUpload
        {...restProps}
        hasError={props.hasError || error !== undefined}
        name={name}
        inputId={fileUploadInputId}
      />
    </FormField>
  );
};
